import { render } from "./AipathHomeUpgrade.vue?vue&type=template&id=316e56dc&scoped=true"
import script from "./AipathHomeUpgrade.vue?vue&type=script&lang=js"
export * from "./AipathHomeUpgrade.vue?vue&type=script&lang=js"

import "./AipathHomeUpgrade.vue?vue&type=style&index=0&id=316e56dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316e56dc"]])

export default __exports__